import { render } from "./tag-button.vue?vue&type=template&id=11637805"
import script from "./tag-button.vue?vue&type=script&lang=js"
export * from "./tag-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__